export const departmentTaxes = () => ({
  entityType: 'DEPARTMENT_TAXES',
  selected: [],
  includedInPrice: false
})

export const departmentPrinting = () => ({
  entityType: 'DEPARTMENT_PRINTING',
  kitchen: {
    entityType: 'MENU_PRINTING_KITCHEN',
    printers: [],
    settings: [],
    excludedSizes: []
  },
  receipt: {
    entityType: 'MENU_PRINTING_RECEIPT',
    settings: [],
    promoMessage: ''
  },
  label: {
    entityType: 'MENU_PRINTING_LABEL',
    printers: []
  }
})

export const departmentKPS = () => ({
  entityType: 'DEPARTMENT_KPS',
  displays: [],
  settings: [],
  excludedSizes: []
})

export const departmentCategorySuggestions = () => ({
  entityType: 'DEPARTMENT_CATEGORY_SUGGESTIONS',
  blockSystemGenerated: false,
  categories: [],
  items: []
})

export const departmentCategoryInclusions = () => ({
  entityType: 'DEPARTMENT_CATEGORY_INCLUSIONS',
  virtualTicketInclusions: false,
  onlyIncludedModifiersOnline: false,
  substitutions: {
    entityType: 'DEPARTMENT_INCLUSIONS_SUBSTITUTIONS',
    allow: true,
    limit: false,
    limitAmount: 1,
    restrictToCategory: false
  },
  categoriesSettings: [],
  itemsSettings: [],
  inclusionsOrder: []
})

export const modifierCategoryPrinting = () => ({
  entityType: 'MODIFIER_CATEGORY_PRINTING',
  kitchenSettings: [],
  receiptSettings: [],
  kpsSettings: []
})
